export enum SourceScreen {
    HOME_PAGE = 'Home Page',
    CAR_LISTING = 'Car Listing',
    CAR_PROFILE = 'Car Profile',
    WHY_SYLNDR = 'Why Sylndr',
}
